import React from "react";
import Masonry from "react-masonry-css";
import { Link } from "react-router-dom";
import "./Gallery.css";

// Imported images
import tmrt from "../../assets/gallery/tmrt/1-1.jpg";
import fire from "../../assets/gallery/消防節/4-1.jpg";
import dragon from "../../assets/gallery/dragon/9-1.jpg";
import tmrt02 from "../../assets/gallery/tmrt2/15-1.jpg";
import gal01 from "../../assets/gallery/gal01.jpg";
import gal02 from "../../assets/gallery/gal02.jpg";
import gal03 from "../../assets/gallery/gal03.jpg";
import gal04 from "../../assets/gallery/gal04.jpg";
import gal05 from "../../assets/gallery/gal05.png";
import gal06 from "../../assets/gallery/gal06.pdf";
import gal07 from "../../assets/gallery/gal07.jpg";
import gal08 from "../../assets/gallery/gal08.jpg";
import gal09 from "../../assets/gallery/gal09.jpg";
import gal10 from "../../assets/gallery/gal10.jpg";
import gal11 from "../../assets/gallery/gal11.jpg";
import gal12 from "../../assets/gallery/gal12.jpg";
import gal13 from "../../assets/gallery/gal13.jpg";
import gal14 from "../../assets/gallery/gal14.jpg";

// Gallery data with IDs
const collections = [
    { id: 1, title: "TMRT", image: tmrt, count: 6 },
    { id: 2, title: "消防節", image: fire, count: 9 },
    { id: 3, title: "dragon", image: dragon, count: 3 },
    { id: 4, title: "TMRT2", image: tmrt02, count: 4 },
    { id: 5, title: "gal01", image: gal01, count: 1 },
    { id: 6, title: "gal02", image: gal02, count: 1 },
    { id: 7, title: "gal03", image: gal03, count: 1 },
    { id: 8, title: "gal04", image: gal04, count: 1 },
    { id: 9, title: "gal05", image: gal05, count: 1 },
    { id: 10, title: "gal06", image: gal06, count: 1 },
    { id: 11, title: "gal07", image: gal07, count: 1 },
    { id: 12, title: "gal08", image: gal08, count: 1 },
    { id: 13, title: "gal09", image: gal09, count: 1 },
    { id: 14, title: "gal10", image: gal10, count: 1 },
    { id: 15, title: "gal11", image: gal11, count: 1 },
    { id: 16, title: "gal12", image: gal12, count: 1 },
    { id: 17, title: "gal13", image: gal13, count: 1 },
    { id: 18, title: "gal14", image: gal14, count: 1 },
];

// Masonry layout breakpoints
const breakpointColumnsObj = {
    default: 3,
    1100: 2,
    700: 1,
};

const Gallery = () => {
    return (
        <div className="gallery-container">
            <Masonry
                breakpointCols={breakpointColumnsObj}
                className="masonry-grid"
                columnClassName="masonry-grid_column"
            >
                {collections.map((item, index) => (
                    <Link
                        to={`/gallery-detail/${item.id}`}
                        className="gallery-item"
                        key={item.id}
                        style={{ animationDelay: `${index * 0.1}s` }}
                    >
                        {/* <div className="image-wrapper">
                            <img src={item.image} alt={item.title} loading="lazy" />
                            <div className="overlay">
                                <h3>{item.title}</h3>
                            </div>
                        </div> */}
                        <div className="image-wrapper">
                            <img src={item.image} alt={item.title} loading="lazy" />
                        </div>
                    </Link>
                ))}
            </Masonry>
        </div>
    );
};

export default Gallery;
